import { MapTo } from '@adobe/aem-react-editable-components';
import AuthorBio, { AuthorBioEditConfig } from './AuthorBio';

export default MapTo('cob-corp-acquisition/components/creditonebank/author-bio')(AuthorBio, AuthorBioEditConfig);